module.exports = __webpack_public_path__ + "img/unit.4fdeeaf7.svg";